export default __webpack_public_path__ + "images/359bd801543b28225226f49fc1f3e914-deciding_which_healthcare_option_is_best.svg";